/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { generateCacheKey } from '@msdyn365-commerce-modules/retail-actions';
import { getContractList_V2Async } from './DataActionExtension.g';
import { IContractListEntity_V2 } from './DataServiceEntities.g';

/**
 * GetContractListV2 Input Action
 */

export class GetContractListV2Input implements Msdyn365.IActionInput {
    private readonly customerAccountNumber: string;
    private readonly customerName: string;

    public constructor(customerAccountNumber: string, customerName: string) {
        this.customerAccountNumber = customerAccountNumber;
        this.customerName = customerName;
    }

    public getCacheKey = () =>
        generateCacheKey(
            undefined,
            { key: 'type', value: 'ContractListV2' },
            { key: 'customerAccountNumber', value: this.customerAccountNumber || 'anonymous' },
            { key: 'customerName', value: this.customerName || 'anonymous' }
        );
    public getCacheObjectType = () => 'ContractListV2';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

const createContractListInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const customerAccountNumber = args.requestContext.user?.customerAccountNumber || '';
    const customerName = args.requestContext.user?.name || '';

    return new GetContractListV2Input(customerAccountNumber, customerName);
};

async function action(input: GetContractListV2Input, ctx: Msdyn365.IActionContext): Promise<IContractListEntity_V2[]> {
    const response = await getContractList_V2Async({ callerContext: ctx });
    return response;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IContractListEntity_V2[]>>action,
    id: 'GetContractListV2',
    input: createContractListInput
});
